import { Box, Grid, Typography } from '@mui/material';
import {
  EMPTY_SUBSTANTIAL_US_OWNERS,
  FatcaStatusNFFE,
  FatcaStatusNFFEOptions,
} from '~/modules/identification/forms/FatcaAdditionalInformation/constants/constants.ts';
import { FormRadioGroup } from '~/components/FormComponents/FormRadioGroup.tsx';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { MultilineTextInput } from '~/components/TextField/MultilineTextInput.tsx';
import { styles } from '~/modules/identification/styles.ts';
import { commonStyles } from '~/theme/styles/commonStyles.ts';
import { SubstantialUSOwners } from '~/modules/identification/forms/FatcaAdditionalInformation/components/SubstantialUSOwners.tsx';
import { useEffect } from 'react';
import { useFilterBeneficiaryOwners } from '~/modules/identification/forms/FatcaAdditionalInformation/hooks/useFilterBeneficiaryOwners.ts';

export const NffeInfo = () => {
  const { combinedOwners } = useFilterBeneficiaryOwners();
  const { control, getValues } = useFormContext();
  const basePath = `nffeInfo`;
  const ownersPath = `${basePath}.substantialUSOwners`;

  const [fatcaStatusNFFE] = useWatch({
    name: [`${basePath}.fatcaStatusNFFE`],
    control,
  });

  const { fields, replace } = useFieldArray({
    control,
    name: ownersPath,
    keyName: 'fieldKey',
  });

  useEffect(() => {
    if (!combinedOwners.length) return;

    const current = getValues(ownersPath) ?? [];

    const next = combinedOwners.map((owner) => {
      const existing = current.find((item: { id?: string }) => item?.id === owner.id);

      return {
        ...EMPTY_SUBSTANTIAL_US_OWNERS,
        ...existing,
        id: owner.id,
        lastName: owner.lastName,
        firstName: owner.firstName,
        middleName: owner.middleName,
      };
    });

    replace(next);
  }, [combinedOwners]);

  const substantialUSOwnersCards =
    combinedOwners.length > 0 &&
    fatcaStatusNFFE === FatcaStatusNFFE.PASSIVE_NFFE_WITH_SUBSTANTIAL_US_OWNERS;

  return (
    <Grid container spacing={3}>
      <FormRadioGroup
        name={`${basePath}.fatcaStatusNFFE`}
        options={FatcaStatusNFFEOptions}
        label={
          'Вкажіть, будь ласка, FATCA-статус Вашої установи і надайте форму W-8 BEN-E або іншу'
        }
      />
      {fatcaStatusNFFE === FatcaStatusNFFE.OTHER && (
        <MultilineTextInput
          name={`${basePath}.otherFatcaStatusNFFE`}
          label={'Інший FATCA-статус NFFE'}
          placeholder="Вкажіть інший FATCA-статус NFFE"
          textSize={500}
        />
      )}
      {substantialUSOwnersCards && (
        <Box sx={{ width: '100%' }}>
          <Typography variant="h6" sx={styles.titleForm}>
            Контролюючі особи та/або власники істотної участі (10% і більше) є громадянами та/або
            резидентами США
          </Typography>
          <Box sx={{ ...commonStyles.columnFlexContainer, gap: 3, mt: 3 }}>
            {fields.map((field, index) => (
              <SubstantialUSOwners key={field.fieldKey} index={index} />
            ))}
          </Box>
        </Box>
      )}
    </Grid>
  );
};
